import BaseService from "../baseService";
import 'url-search-params-polyfill';
import '../../../utils/http/url';


const SERVER_ENDPOINT_PATH = "/interact";
const REPORTS_ENDPOINT_PATH = "/reports";
const AGENTAPP_ENDPOINT_PATH = "/interact/index";
const MOBILE_ENDPOINT_PATH = "/interact/index";
const WEBAGENT_ENDPOINT_PATH = "/webselfservice/start.html"
const POPOVER_ENDPOINT_PATH = "/webselfservice/popover.html";
const EMBEDDED_ENDPOINT_PATH = "/interact/index";
const UADAPP_ENDPOINT_PATH = "/interact/index";

class UrlService extends BaseService{




	constructor(){
		super('com.jacada.common.UrlService');
		this.loadUrl(window.location.href);
	}

	loadUrl(url) {
		this.url = url;
		let parts = url.split('?');
		if (parts.length < 2) {
			//throw new Error("missing url params");
			this.urlSearchParams = new URLSearchParams();
		} else {
			this.urlSearchParams = new URLSearchParams(parts[1]);
		}
	}

	getSearchParam(name) {
		return this.urlSearchParams.get(name);
	}

	getSearchParamsMap() {
		let params = {};
		for(let pair of this.urlSearchParams.entries()) {
			params[pair[0]] = pair[1];
		}
		return params;
	}

	getPathName(urlText){
		let pathName;
		if (urlText.indexOf("?") > -1){
			pathName = urlText.substring(urlText.indexOf("//") + 2, urlText.indexOf("?"));
		}else{
			pathName = urlText.substring(urlText.indexOf("//") + 2);
		}

		return pathName;
	}

	getSearchParamsFromUrl(url) {
		let parts = url.split('?');
		let searchParams;
		if (parts.length < 2) {
			searchParams = new URLSearchParams();
		}else{
			searchParams = new URLSearchParams(parts[1]);
		}

		return searchParams;
	}

	getBaseUrl() {
		return window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
	}

	getServerEndpointUrl() {
		return this.getBaseUrl() + SERVER_ENDPOINT_PATH;
	}

	getReportsUrl() {
		return this.getBaseUrl() + REPORTS_ENDPOINT_PATH;
	}

	getAgentAppUrl() {
		return this.getBaseUrl() + AGENTAPP_ENDPOINT_PATH;
	}

	getMobileUrl() {
		return this.getBaseUrl() + MOBILE_ENDPOINT_PATH;
	}

	getWebAgentUrl() {
		return this.getBaseUrl() + WEBAGENT_ENDPOINT_PATH;
	}

	getPopoverUrl() {
		return this.getBaseUrl() + POPOVER_ENDPOINT_PATH;
	}

	getEmbeddedUrl() {
		return this.getBaseUrl() + EMBEDDED_ENDPOINT_PATH;
	}

	getUadAppURL() {
		return this.getBaseUrl() + UADAPP_ENDPOINT_PATH;
	}
}

export default new UrlService();



// WEBPACK FOOTER //
// ../common/services/src/url/urlService.js